import DOMPurify from 'dompurify'

/**
 * HTML from the webhook (allowHTMLInResponses). Model output can be steered
 * by user input, so it is treated as untrusted: DOMPurify removes scripts,
 * event handlers and javascript:/data: URLs, links open in a new tab.
 */
export function sanitizeHtml(unsafeHtml: string): string {
  const clean = DOMPurify.sanitize(unsafeHtml, {
    FORBID_TAGS: ['style', 'form', 'input', 'button', 'textarea', 'select', 'iframe', 'object', 'embed'],
    ADD_ATTR: ['target'],
  })
  const temp = document.createElement('div')
  temp.innerHTML = clean
  temp.querySelectorAll('a[href]').forEach((a) => {
    a.setAttribute('target', '_blank')
    a.setAttribute('rel', 'noopener noreferrer')
  })
  return temp.innerHTML
}
